/** Read saved sidebar collapsed preference (matches Sidebar.jsx). */
export function readSidebarCollapsedPref(getItem) {
  try {
    return Boolean(getItem?.("sidebarCollapsed", true));
  } catch {
    return false;
  }
}

export const BOOT_SIDEBAR_LINK_COUNT = 11;
export const BOOT_SIDEBAR_LABEL_WIDTHS = [
  120, 90, 110, 100, 130, 95, 105, 80, 115, 125, 92,
];
export const BOOT_NAVBAR_ICON_COUNT = 6;
